import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		loading: false,
		bot: null,
		user: null,
		chats: [],
		currentAction: null,
		currentGroup: null,
		client: '',
		reversed: false,
		noWait: false,
		noTyping: false,
		readonly: false,
		uid: null,
		bid: null,
		mode: 'normal',
		style: ''
	}
});

window.$store = store;

export default store;
